const appConfig = {
  ENABLE_LOGGER: true,   // 🔥 Toggle logger ON/OFF here
  LOG_LEVEL: "debug", 
  SEND_LOGS_TO_SERVER: true   // debug | info | error
};

export default appConfig;